import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import { ClientService } from "@services";
import utils from "@utils";
import { ScrollDetect, Image } from "../../../../components";

const displayCount = 10;

class ActivityTab extends Component {
	constructor() {
		super();
		this.state = {
			activities: [],
			pagingToken: null,
			hasNext: true,
			activeDates: [],
		};
	}

	/** Retrieve a paginated list of activities (notes) pertaining the the client */
	getActivities = () => {
		const { lang } = global;
		const { clientId: id } = this.props;
		const { pagingToken, hasNext } = this.state;
		if (!id) return;
		if (hasNext) {
			ClientService.getPosts({ id, pagingToken, displayCount })
				.then(({ data }) => {
					const activities = data.ItemList.map((item, index) => ({
						id: `activity_${item.JobId}_${item.JobEventId}_${item.DateUTC}_${index}`,
						type: item.TypeName || "",
						title: item.Title || "",
						content: item.Content || "",
						dateUTC: item.DateUTC || "",
						image: item.ImageUrl || "",
						postedBy: `${item.UserFirstName} ${item.UserLastName}`,
						jobEventId: item.JobEventId || "",
					}));

					this.setState(prevState => ({
						activities: [...prevState.activities, ...activities],
						pagingToken: data.PagingToken,
						hasNext: data.HasNext,
						activeDates: [
							...prevState.activeDates,
							...new Set(data.ItemList.map(({ DateUTC }) => DateUTC.split("T")[0])),
						],
					}));
				})
				.catch(() => {
					this.setState({
						activities: [],
						pagingToken: null,
						hasNext: false,
					});
					utils.notify({
						type: "error",
						message: lang.t("Unable to load activities"),
					});
				});
		}
	};

	/**
	 * Checks whether an activity took place on a given date
	 * @param {String} date A date string
	 * @param {Object} activity An object representing a client activity
	 * @returns `true` if the the activity occurred on the date provided, `false` otherwise
	 */
	activityDate = (date, activity) => {
		const { dateUTC } = activity;
		const dateMs = new Date(`${date}T00:00:00`).getTime();
		const nextDayMs = dateMs + 1000 * 60 * 60 * 24;
		const activeDatetMs = new Date(`${dateUTC}Z`).getTime();
		return activeDatetMs >= dateMs && activeDatetMs <= nextDayMs;
	};

	render() {
		const { user } = this.props;
		const { activities, hasNext, activeDates } = this.state;
		return (
			<div id="client-view-activities">
				<For
					each="date"
					of={activeDates}
				>
					<div
						className="row"
						key={`activity_${date}`}
					>
						<div className="col-sm-12">
							<h4>
								{utils.formatDate(
									new Date(`${date}T00:00:00`),
									"en-US",
									undefined,
									"w-long",
								)}
							</h4>
						</div>
					</div>
					<For
						each="activity"
						of={activities}
					>
						<If condition={this.activityDate(date, activity)}>
							<div
								className="row"
								key={activity.id}
							>
								<div className="col-xs-4 col-sm-2 text-right">
									<strong>
										{utils.formatTime(
											new Date(`${activity.dateUTC}Z`),
											true,
											user.TimeZoneId,
										)}
									</strong>
								</div>
								<div className="col-xs-8 col-sm-6 activity-content">
									<strong>{activity.type}</strong>
									<div>
										<Link to={`/jobs/${activity.jobEventId}`}>
											{activity.title} - (#{activity.jobEventId})
										</Link>
									</div>
									<em>{activity.content}</em>
									<div>{`Posted by: ${activity.postedBy}`}</div>
								</div>
								<div className="col-xs-12 col-sm-4">
									<If condition={activity.image}>
										<a
											href={activity.image}
											target="_blank"
											rel="noopener noreferrer"
										>
											<Image
												className="img-responsive"
												src={activity.image}
												fallbackSrc="default"
											/>
										</a>
									</If>
								</div>
							</div>
						</If>
					</For>
				</For>
				<If condition={hasNext}>
					<ScrollDetect
						className="text-center"
						onVisible={this.getActivities}
					>
						<i className="glyphicon glyphicon-repeat rkf-spin rkf-fw" />
					</ScrollDetect>
				</If>
			</div>
		);
	}
}

ActivityTab.propTypes = {
	clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	user: PropTypes.object,
};

ActivityTab.defaultProps = {
	clientId: "",
	user: {},
};

export default ActivityTab;
